import "./AddAccount.scss";
import React, { useEffect, useState } from "react";
import {
  IonButton,
  IonInput,
  IonLabel,
  IonList,
  IonItem,
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonBackButton,
  IonFooter,
  IonLoading,
  useIonViewWillEnter,
  IonIcon,
  IonModal,
} from "@ionic/react";
import {
  ShowToastErrorMessage,
  ShowToastSuccessMessage,
} from "../../utils/helpers/ToastMessage";
import { useHistory, useParams } from "react-router-dom";
import isValidUTF8 from "utf-8-validate";
import briefcaseIcon from "../../assets/svg/accountIcons/briefcase.svg";

import {
  createAccount,
  getUserByIdentity,
  requestCreateAccount,
  updateUser,
} from "../../api/user";
import { createRequestHistory } from "../../api/requestHistory";
import { v4 } from "uuid";
import { useTracked } from "../../state";
import { getAccountIcon } from "../../utils/helpers/AccountIcon";
import CheckEmailModal from "../../components/CheckEmailModal";
import CreatingIdentity from "../../components/CreatingIdentity";
import LabelIconDropdown from "../../components/LabelIconDropdown";
import MockDelay from "../../utils/helpers/MockDelay";
import clsx from "clsx";

const AddAccount: React.FC = () => {
  const history = useHistory();
  const params: any = useParams();
  const id = params["id"];
  const [state, dispatch] = useTracked();
  const [accountLabel, setAccountLabel] = useState<any>("");
  const [accountEmail, setAccountEmail] = useState<any>("");
  const [accountLabelError, setAccountLabelError] = useState<any>("");
  const [accountEmailError, setAccountEmailError] = useState<any>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedIcon, setSelectedIcon] = useState<any>(briefcaseIcon);
  const [selectedColor, setSelectedColor] = useState<any>("#53A6DE");
  const [selectedIconName, setSelectedIconName] = useState<any>("briefcase");
  const [isOpenCheckEmail, setIsOpenCheckEmail] = useState<boolean>(false);
  const [isOpenCreatingAccountModal, setIsOpenCreatingAccountModal] =
    useState<boolean>(false);
  const [loadingText, setLoadingText] = useState<string>(
    "Creating your secure identity"
  );
  const [progressValue, setProgressValue] = useState<any>(0);
  const [isAccountCreated, setIsAccountCreated] = useState<boolean>(false);

  useIonViewWillEnter(() => {
    setAccountLabel("");
    setAccountEmail("");
    setAccountLabelError("");
    setAccountEmailError("");
    setSelectedColor("#53A6DE");
    setSelectedIcon(briefcaseIcon);
    setSelectedIconName("briefcase");
  });

  useEffect(() => {
    if (id) {
      fetchAccount(id);
    }
  }, [id]);

  useEffect(() => {
    if (
      state.accountCreateApproved &&
      accountEmail &&
      accountLabel &&
      selectedColor &&
      selectedIconName &&
      state.accountCreateApproved === accountEmail
    ) {
      createNewAccount(
        accountEmail,
        accountLabel,
        selectedColor,
        selectedIconName
      );

      dispatch({
        type: "setAccountCreateApproved",
        accountCreateApproved: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.accountCreateApproved,
    accountEmail,
    accountLabel,
    selectedIconName,
    selectedColor,
  ]);

  const fetchAccount = async (id: string) => {
    try {
      setIsLoading(true);
      const response: any = await getUserByIdentity(id);

      if (response?.status === 200 && response?.data?.id) {
        const { email, accountLabel, accountColor, accountIcon } =
          response.data;
        setAccountEmail(email);
        setAccountLabel(accountLabel || "");
        setSelectedColor(accountColor || "");

        if (accountIcon) {
          const icon = getAccountIcon(accountIcon);
          setSelectedIcon(icon);
          setSelectedIconName(accountIcon);
        }
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const createNewAccount = async (
    email: string,
    label: string,
    color: string,
    icon: string
  ) => {
    try {
      setIsOpenCheckEmail(false);
      setIsOpenCreatingAccountModal(true);
      setLoadingText("Creating your secure identity");
      setProgressValue(0.25);

      const response: any = await createAccount({
        email,
        accountIcon: icon,
        accountColor: color,
        accountLabel: label,
        identity: state.identity,
        isFirstTimeLogin: false,
      });

      if (response?.status === 200 && response?.data?.id) {
        dispatch({ account: response.data, type: "setAccount" });

        await MockDelay(3000);

        setLoadingText("Storing your identity on-chain");
        setProgressValue(0.5);
        await MockDelay(3000);

        setLoadingText("Populating credentials");
        setProgressValue(0.75);
        await MockDelay(3000);

        setLoadingText("Finalizing...");
        setProgressValue(1);
        await MockDelay(3000);

        setIsAccountCreated(true);
        ShowToastSuccessMessage("New account successfully added");
      } else {
        ShowToastErrorMessage("Create new account failed");
      }

      setIsOpenCreatingAccountModal(false);
      dispatch({
        type: "setClientReferenceId",
        clientReferenceId: null,
      });

      setTimeout(() => {
        history.push("/accounts");
      }, 500);
    } catch (e) {
      console.log(e);
      ShowToastErrorMessage("Create new account failed");
      setIsOpenCreatingAccountModal(false);
      dispatch({
        type: "setClientReferenceId",
        clientReferenceId: null,
      });

      setTimeout(() => {
        history.push("/accounts");
      }, 500);
    }
  };

  // const createNewAccount = async (
  //   email: string,
  //   label: string,
  //   color: string,
  //   icon: string
  // ) => {
  //   try {
  //     setIsOpenCheckEmail(false);

  //     let isApiCallDone = false;
  //     let isMockProgressDone = false;

  //     // console.log("called create new account!");
  //     setIsOpenCreatingAccountModal(true);

  //     createAccount({
  //       email,
  //       accountIcon: icon,
  //       accountColor: color,
  //       accountLabel: label,
  //       identity: state.identity,
  //       isFirstTimeLogin: false,
  //     })
  //       .then((response: any) => {
  //         console.log("createAccount", response);

  //         isApiCallDone = true;

  //         if (response?.status === 200 && response?.data?.id) {
  //           dispatch({ account: response.data, type: "setAccount" });

  //           if (isMockProgressDone) {
  //             setIsAccountCreated(true);
  //             ShowToastSuccessMessage("New account successfully added");
  //             setIsOpenCreatingAccountModal(false);
  //             dispatch({
  //               type: "setClientReferenceId",
  //               clientReferenceId: null,
  //             });

  //             setTimeout(() => {
  //               history.push("/accounts");
  //             }, 500);
  //           }
  //         } else {
  //           ShowToastErrorMessage("Create new account failed");
  //         }
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         ShowToastErrorMessage("Create new account failed");
  //       });

  //     setLoadingText("Creating your secure identity");
  //     setProgressValue(0.25);
  //     await MockDelay(3000);

  //     setLoadingText("Storing your identity on-chain");
  //     setProgressValue(0.5);
  //     await MockDelay(3000);

  //     setLoadingText("Populating credentials");
  //     setProgressValue(0.75);
  //     await MockDelay(3000);

  //     setLoadingText("Finalizing...");
  //     setProgressValue(1);
  //     await MockDelay(3000);
  //     isMockProgressDone = true;

  //     if (isApiCallDone) {
  //       setIsAccountCreated(true);
  //       ShowToastSuccessMessage("New account successfully added");
  //       setIsOpenCreatingAccountModal(false);
  //       dispatch({ type: "setClientReferenceId", clientReferenceId: null });

  //       setTimeout(() => {
  //         history.push("/accounts");
  //       }, 500);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     ShowToastErrorMessage("Create new account failed");
  //   }
  // };

  const handleAccountLabelChange = (e: any) => {
    const { value } = e.target;
    setAccountLabelError("");
    setAccountLabel(value);
  };

  const handleAccountEmailChange = (e: any) => {
    const { value } = e.target;
    setAccountEmailError("");
    setAccountEmail(value);
  };

  const handleSubmitBtnClick = async () => {
    try {
      const b = Buffer.from(accountLabel);
      if (!accountLabel) {
        setAccountLabelError("Label is required");
        // ShowToastErrorMessage("Label is required");
        return;
      } else if (!isValidUTF8(b)) {
        setAccountLabelError("Label has invalid characters.");
        // ShowToastErrorMessage("Label has invalid characters.");
        return;
      }

      if (!accountEmail) {
        setAccountEmailError("Email is required");
        // ShowToastErrorMessage("Email is required");
        return;
      }

      const isEmail: RegExp =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!isEmail.test(accountEmail.toLowerCase())) {
        setAccountEmailError("Please enter a valid email address");
        // ShowToastErrorMessage("Please enter a valid email address");
        return;
      }

      // if (accountEmail.indexOf('_') !== -1) {
      //   setAccountEmailError("Underscores are not allowed");
      //   // ShowToastErrorMessage("Please enter a valid email address");
      //   return;
      // }

      setIsLoading(true);

      if (id) {
        const response: any = await updateUser(id, {
          accountIcon: selectedIconName,
          accountColor: selectedColor,
          accountLabel: accountLabel,
        });

        if (response?.status === 200) {
          const user: any = await getUserByIdentity(id);

          await createRequestHistory({
            user: state.user,
            name: " ",
            alias: user.data.email,
            type: "update_account",
            status: "UPDATED",
            appId: 1, // verifier app ID -> always on verifier app
            createdId: state.user.id,
          });

          if (user?.data?.id) {
            dispatch({ type: "setUser", user: user.data });
            dispatch({ type: "setAccount", account: user.data });
          }

          ShowToastSuccessMessage("Changes of account successfully saved");
        } else {
          const msg = response?.message || "Edit account failed";
          ShowToastErrorMessage(msg, {
            autoClose: 8000,
          });
        }

        history.replace("/accounts");
      } else {
        const clientReferenceId = v4();
        const response: any = await requestCreateAccount(
          accountEmail,
          clientReferenceId
        );

        if (response?.status === 200 && response?.token) {
          dispatch({ type: "setClientReferenceId", clientReferenceId });
          setIsOpenCheckEmail(true);
        } else {
          const msg = response?.message || "Email already exists";
          ShowToastErrorMessage(msg, {
            autoClose: 8000,
          });
        }
      }

      setIsLoading(false);

      // if (resp?.status === 200) {
      //   setAccountLabel("");
      //   setAccountEmail("");
      //   if (id) {
      //     ShowToastSuccessMessage("Changes of account successfully saved");
      //   } else {
      //     ShowToastSuccessMessage("New account successfully added");
      //   }

      //   history.replace("/accounts");
      // } else {
      //   if (id) {
      //     const msg = resp?.message || "Edit account failed";
      //     ShowToastErrorMessage(msg);
      //   } else {
      //     const msg = resp?.message || "Save new account failed";
      //     ShowToastErrorMessage(msg);
      //   }
      // }
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      if (id) {
        ShowToastErrorMessage("Edit account failed");
      } else {
        ShowToastErrorMessage("Save new account failed");
      }
    }
  };

  return (
    <IonPage className="add-alias-page">
      <IonHeader className="ion-no-border" mode="ios">
        <IonToolbar mode="ios">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/accounts" text="" />
          </IonButtons>

          {id && <IonTitle>Edit account</IonTitle>}
          {!id && <IonTitle>Add account</IonTitle>}
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div className="add-alias-form">
          <IonList lines="none" mode="ios">
            <IonItem detail={false}>
              <IonLabel position="stacked">Label</IonLabel>
              <IonInput
                name="accountLabel"
                placeholder="Enter label"
                value={accountLabel}
                type="text"
                onIonChange={handleAccountLabelChange}
                maxlength={48}
                className={clsx({ "has-error": !!accountLabelError })}
              />
              <div
                className="label-icon-btn"
                id="trigger-button"
                style={{
                  background: selectedColor,
                }}
              >
                <IonIcon icon={selectedIcon} />
              </div>
              {accountLabelError && (
                <div className="error-text">{accountLabelError}</div>
              )}
            </IonItem>

            <IonItem detail={false}>
              <IonLabel position="stacked">Email</IonLabel>
              <IonInput
                name="accountEmail"
                type="email"
                inputMode="email"
                placeholder="Enter your email"
                value={accountEmail}
                maxlength={144}
                readonly={id}
                disabled={id ? true : false}
                onIonChange={handleAccountEmailChange}
                className={clsx({ "has-error": !!accountEmailError })}
              />
              {accountEmailError && (
                <div className="error-text">{accountEmailError}</div>
              )}
            </IonItem>
          </IonList>
        </div>
      </IonContent>

      <IonFooter className="ion-no-border" mode="ios">
        <IonButton
          color="danger"
          expand="block"
          shape="round"
          onClick={handleSubmitBtnClick}
          disabled={!accountLabel || !accountEmail}
        >
          Save
        </IonButton>
      </IonFooter>

      {isLoading && <IonLoading isOpen={isLoading} />}

      <LabelIconDropdown
        selectedIcon={selectedIcon}
        selectedIconName={selectedIconName}
        selectedColor={selectedColor}
        onSetSelectedIcon={setSelectedIcon}
        onSetSelectedIconName={setSelectedIconName}
        onSetSelectedColor={setSelectedColor}
      />

      <CheckEmailModal isOpen={isOpenCheckEmail} />

      <IonModal
        isOpen={isOpenCreatingAccountModal}
        className="creating-account-modal"
        onDidDismiss={() => {
          setIsOpenCreatingAccountModal(false);
        }}
      >
        <CreatingIdentity
          inProgressTitle="Creating Account..."
          finishTitle="Account Created!"
          loadingText={loadingText}
          progressValue={progressValue}
          isAccountCreated={isAccountCreated}
        />
      </IonModal>
    </IonPage>
  );
};

export default AddAccount;
